import { render, staticRenderFns } from "./prnpolicyconsultreply.vue?vue&type=template&id=10b6ee6c"
import script from "./prnpolicyconsultreply.vue?vue&type=script&lang=js"
export * from "./prnpolicyconsultreply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports